import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { Transaction } from "@roman/shared/types/transaction";
import { useEffect } from "react";
import useSWR from "swr";

interface useTransactionsResponse {
  transactions: Transaction[];
}

const fetcher = (url: string): Promise<useTransactionsResponse> => {
  const headers = authHeader.getOrThrow();
  return romanApi.get<useTransactionsResponse>(url, undefined, { headers });
};

export const useTransactions = (userId: string, handleError: (err: RomanApiError) => void) => {
  const { data, isLoading, error } = useSWR<useTransactionsResponse, RomanApiError>(
    userId ? `/transactions/${userId}` : null,
    fetcher,
  );

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  return {
    data: data?.transactions,
    isLoading,
  };
};
